import axios from 'axios'
import { useClienteAuthStore } from '@/stores/clienteAuth'

// Reutilizar la misma lógica de URL base que initmixin
let host = (window.location.host).replace(':8080', '')
host = (host).replace(':8081', '')
let domain = host.split('.')[0]
let baseURL = ''
switch (domain) {
  case 'marbel-pop':
  case 'mb-front-9wwke':
  case 'marbel-prod':
  case 'marbel-dev':
    baseURL = 'https://marbel-backend.iteracrea.com'
    break
  default:
    baseURL = 'http://localhost:8000'
    break
}

const api = axios.create({
  baseURL,
  headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
  timeout: 30000
})

function authHeaders() {
  const store = useClienteAuthStore()
  return { Authorization: 'Bearer ' + store.token }
}

function handleError(error) {
  if (error.response) {
    const { status, data } = error.response
    return {
      success: false,
      status,
      message: data.message || 'Error del servidor',
      errors: data.errors || null,
      data: null
    }
  }
  return {
    success: false,
    status: 0,
    message: 'Error de conexión. Verifica tu internet e intenta nuevamente.',
    errors: null,
    data: null
  }
}

export default {
  // --- Auth OTP ---
  solicitarOTP: async (phone) => {
    try {
      const res = await api.post('/api/cliente/solicitar-otp', { phone })
      return { success: true, data: res.data, message: res.data.message }
    } catch (e) { return handleError(e) }
  },

  verificarOTP: async (phone, code) => {
    try {
      const res = await api.post('/api/cliente/verificar-otp', { phone, code })
      return { success: true, data: res.data, message: res.data.message }
    } catch (e) { return handleError(e) }
  },

  // --- Catálogos (públicos) ---
  getCatalogos: async () => {
    try {
      const [regimenes, usos, formas] = await Promise.all([
        api.get('/api/catalogos/regimenes-fiscales'),
        api.get('/api/catalogos/usos-cfdi'),
        api.get('/api/catalogos/formas-pago')
      ])
      return {
        success: true,
        data: {
          regimenes: regimenes.data,
          usosCfdi: usos.data,
          formasPago: formas.data
        }
      }
    } catch (e) { return handleError(e) }
  },

  // --- Datos Fiscales ---
  getDatosFiscales: async () => {
    try {
      const res = await api.get('/api/cliente/datos-fiscales', { headers: authHeaders() })
      return { success: true, data: res.data }
    } catch (e) { return handleError(e) }
  },

  guardarDatosFiscales: async (datos) => {
    try {
      const res = await api.post('/api/cliente/datos-fiscales', datos, { headers: authHeaders() })
      return { success: true, data: res.data, message: 'Datos fiscales guardados.' }
    } catch (e) { return handleError(e) }
  },

  // --- Órdenes ---
  getOrdenes: async () => {
    try {
      const res = await api.get('/api/cliente/ordenes', { headers: authHeaders() })
      return { success: true, data: res.data }
    } catch (e) { return handleError(e) }
  },

  // --- Facturación ---
  generarFactura: async (cotizacion_id, forma_pago) => {
    try {
      const res = await api.post('/api/cliente/factura', { cotizacion_id, forma_pago }, { headers: authHeaders() })
      return { success: true, data: res.data }
    } catch (e) { return handleError(e) }
  },

  getFacturas: async () => {
    try {
      const res = await api.get('/api/cliente/facturas', { headers: authHeaders() })
      return { success: true, data: res.data }
    } catch (e) { return handleError(e) }
  },

  descargarPDF: (facturaId) => {
    const store = useClienteAuthStore()
    return api.get(`/api/cliente/factura/${facturaId}/pdf`, {
      headers: { Authorization: 'Bearer ' + store.token },
      responseType: 'blob'
    })
  },

  descargarXML: (facturaId) => {
    const store = useClienteAuthStore()
    return api.get(`/api/cliente/factura/${facturaId}/xml`, {
      headers: { Authorization: 'Bearer ' + store.token },
      responseType: 'blob'
    })
  }
}
